import { Component, OnInit, HostListener } from '@angular/core';
import { RestApiService } from '../../rest-api.service';

@Component({
  selector: 'app-base-inventory',
  templateUrl: './base-inventory.component.html',
  styleUrls: ['./base-inventory.component.css']
})
export class BaseInventoryComponent implements OnInit {
  public getInventoryEndpoint: any;
  public inventory: any;
  public galleryView: any[];
  private currentCols: number;

  constructor(public restApi: RestApiService) {
    // default setting of getInventoryEndpoint from rest api
    this.getInventoryEndpoint = this.restApi.getAllWorks;
  }

  ngOnInit() {
    this.init();
  }

  private async init(): Promise<any> {
    this.inventory = await this.getInventory();
    this.galleryView = this.buildGalleryView();
  }

  public async getInventory(): Promise<any> {
    const response = await this.getInventoryEndpoint.call(this.restApi);
    const data = response.data;
    return data;
  }

  public buildGalleryView(): any[] {
    const cols = window.innerWidth < 580 ? 1 : 3;
    let galleryView: any[] = [];
    if (cols === 3) {
      galleryView = [[], [], []];
      for (let i = 0; i < this.inventory.length; i++) {
       if (i % 3 === 0) {
         galleryView[1].push(this.inventory[i]);
       } else if (i % 3 === 1) {
         galleryView[0].push(this.inventory[i]);
       } else {
         galleryView[2].push(this.inventory[i]);
       }
      }
    } else {
      galleryView = [this.inventory];
    }
    return galleryView;
  }

  @HostListener('window:resize', ['$event'])
    onResize(event) {
      const newCols = window.innerWidth < 580 ? 1 : 3;
      if (newCols !== this.currentCols) {
        this.currentCols = newCols;
        this.galleryView = this.buildGalleryView();
      }
    }

}
